import { Controller } from "@hotwired/stimulus";

export default class DarkModeController extends Controller {
    static targets = [ "toggleButton", "darkIcon", "lightIcon" ]

    connect() {
        this.applyTheme(); // Sprawdź i zastosuj zapisany motyw przy podłączeniu kontrolera
    }

    applyTheme() {
        const storedTheme = localStorage.getItem('color-theme');
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

        if (storedTheme === 'dark' || (!storedTheme && prefersDark)) {
            document.documentElement.classList.add('dark');
            this.lightIconTarget.classList.remove('hidden');
            this.darkIconTarget.classList.add('hidden');
        } else {
            document.documentElement.classList.remove('dark');
            this.darkIconTarget.classList.remove('hidden');
            this.lightIconTarget.classList.add('hidden');
        }
    }

    toggleTheme() {
        const isCurrentlyDark = document.documentElement.classList.contains('dark');

        document.documentElement.classList.toggle('dark');

        if (isCurrentlyDark) {
            localStorage.setItem('color-theme', 'light');
            this.darkIconTarget.classList.remove('hidden');
            this.lightIconTarget.classList.add('hidden');
        } else {
            localStorage.setItem('color-theme', 'dark');
            this.lightIconTarget.classList.remove('hidden');
            this.darkIconTarget.classList.add('hidden');
        }
    }
}